import { registerCanvasProjectionDefinition } from '../../components/canvas/projections/CanvasProjectionRegistry';
import {
  POSITION_STAFFING_PROJECTION_KIND,
  PositionStaffingWorkbenchPane,
} from '../orgchart/components/PositionStaffingWorkbenchPane';
import { RegisteredCanvasProjectionPane } from './RegisteredCanvasProjectionPane';

let registered = false;

export function registerCanvasProjectionPanes(): void {
  if (registered) return;
  registered = true;

  registerCanvasProjectionDefinition({
    kind: 'atlas-workload',
    component: RegisteredCanvasProjectionPane,
    supportsDiagramType: (diagramType) => diagramType === 'org',
  });
  registerCanvasProjectionDefinition({
    kind: POSITION_STAFFING_PROJECTION_KIND,
    component: PositionStaffingWorkbenchPane,
    supportsDiagramType: (diagramType) => diagramType === 'org',
  });
  registerCanvasProjectionDefinition({
    kind: 'blueprint-review',
    component: RegisteredCanvasProjectionPane,
    supportsDiagramType: (diagramType) => diagramType === 'network',
  });
}
